export enum CarePlanNotReviewedPeriodEnum {
    Last90DaysDescription = 'Last 90 Days',
    Last90Days = 1,
    Last180DaysDescription = 'Last 180 Days',
    Last180Days = 2,
    Last1YearDescription = 'Last 1 Year',
    Last1Year = 3,
    CustomDescription = 'Custom',
    Custom = 4
}
